import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {AdminUser, InvitationPayload} from "../models/Authentication";

const ADMIN_USER_URL = '/user';
const ME_URL = `${ADMIN_USER_URL}/me`
const INVITE_URL = `${ADMIN_USER_URL}/invite`;
const ADMIN_ID_URL = (id: string | number) => `${ADMIN_USER_URL}/${id}`;


@Injectable({providedIn: 'root'})

export class AdminUserService {

  constructor(private http: HttpClient) {}

  getMe(): Observable<AdminUser> {
    return this.http.get<AdminUser>(ME_URL).pipe(
      map((admin: AdminUser) => new AdminUser(admin))
    );
  }

  inviteAdminUser(invitationInfo: InvitationPayload): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(INVITE_URL, invitationInfo);
  }

  getAllAdminUsers(): Observable<AdminUser[]> {
    return this.http.get<AdminUser[]>(ADMIN_USER_URL).pipe(
      map((admins: AdminUser[]) => admins.map(admin => new AdminUser(admin)))
    );
  }

  getAdminUser(adminId: string): Observable<AdminUser> {
    return this.http.get<AdminUser>(ADMIN_ID_URL(adminId)).pipe(
      map((user: AdminUser) => new AdminUser(user))
    );
  }

  updateAdminUser(admin: AdminUser): Observable<{message: string}> {
    return this.http.put<{message: string}>(ADMIN_ID_URL(admin.id), {admin});
  }

  deleteAdminUser(userId: number): Observable<{message: string}> {
    return this.http.delete<{message: string}>(ADMIN_ID_URL(userId));
  }
}
